import type { ReactNode } from 'react';
import { ChunkRecoveryProvider } from '@mbbe/ui';
import { useLanguage } from '../contexts/LanguageContext';
import { mainDrafts, mainRecovery } from './chunkRecovery';

/** Binds the shared recovery controller to the active UI language. */
export function MainChunkRecovery({ children }: { children: ReactNode }) {
  const { language } = useLanguage();
  return (
    <ChunkRecoveryProvider controller={mainRecovery} drafts={mainDrafts} language={language === 'en' ? 'en' : 'tr'}>
      {children}
    </ChunkRecoveryProvider>
  );
}
